import '../../style/index.css';
import './index.css'; // style dependencies

import '../../empty/style/css';
import '../../spin/style/css';
import '../../pagination/style/css';
import '../../grid/style/css';
//# sourceMappingURL=css.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/list/style/css.js
// module id = 2585
// module chunks = 0